<template lang="pug">
  v-divider(:style="{margin: `0 0 0 ${inset}px`}")
  //- hr.v-divider.theme--dark.theme--light
</template>
<script>
export default {
  name: 'Divider',
  props: { inset: {} },
};
</script>